export const TEXT_KEYS = {
    DROPDOWN_BUTTON: "si.components.countries_dd.button.text.single",
    DROPDOWN_PLACEHOLDER: "si.components.countries_selection_modal.dd_placeholder",
    TOOLTIP_DISABLED_VISITS_SECTION: "si.lead_gen_filters.group.international_visits.tooltip.disabled_slider",
    CONTENT_WW_NOT_SUPPORTED: "si.lead_gen_filters.group.international_visits.tooltip.disabled.secondary",
    HEADER_WW_NOT_SUPPORTED: "si.lead_gen_filters.group.international_visits.hook.header",
    BUTTON_HOOK: "si.lead_gen_filters.group.international_visits.button.hook",
} as const;
